import { TranslateService } from 'Public_old/src/app/Common/Services/translate.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SpaContext } from '../../Classes/spacontext';
import { ApiResponse } from '../../Classes/visibaHttp.class';
import { AuthServiceV2 } from '../../Services/api/v2/auth.service';
import { SmsStartAuthApiResult } from '../../Services/Models/Auth/SmsStartAuthApiResult';
import type { SignInOnFinishedEvent } from './SignInOnFinishedEvent';

@Component({
	standalone: false,
	template: `
		<form novalidate (ngSubmit)="onSubmit()" #form="ngForm">
			<div class="row codeField">
				<visiba-input
					required
					[(ngModel)]="model.name"
					name="name"
					placeholder="LicenceHolder.Component.NoAuthLoginComponent.Placeholder.Name"
				></visiba-input>
			</div>
			<div class="row err" *ngIf="errorMessage != null">{{ errorMessage }}</div>
			<div class="row">
				<button class="btn darkTeal" [disabled]="!form.form.valid">
					{{ 'LicenceHolder.Component.NoAuthLoginComponent.Button.Submit' | translate }}
				</button>
			</div>
		</form>
		<div class="row error" *ngIf="errorMessage != null">{{ errorMessage }}</div>
	`,
	selector: 'no-auth-login',
})
export class NoAuthLoginComponent {
	@Output() onFinished = new EventEmitter<SignInOnFinishedEvent>();
	@Input('ticket') callTicket: string = null;
	@Input() countryCode: string = null;
	public attempt: SmsStartAuthApiResult = null;
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	public model: any = { name: '' };
	public errorMessage: string = null;

	constructor(
		private spaContext: SpaContext,
		private authService: AuthServiceV2,
		private translateService: TranslateService,
	) {}

	ngOnInit() {
		this.authService.startNoAuthAuth(this.spaContext.unitConfig.Unit.UnitId, this.callTicket, this.countryCode).subscribe(
			(response) => {
				// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
				this.attempt = response.data as any;
			},
			// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
			(err: ApiResponse<any>) => {
				this.errorMessage = this.translateService.get('LicenceHolder.Component.NoAuthLoginComponent.Phrase.ErrorMessage');
			},
		);
	}

	public onSubmit() {
		this.authService.confirmNoAuthIdentity(this.spaContext.unitConfig.Unit.UnitId, this.attempt.AttemptId, this.model.name).subscribe(
			(response) => {
				this.onFinished.emit({ code: 'Signed' });
			},
			// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
			(err: ApiResponse<any>) => {
				this.errorMessage = this.translateService.get('LicenceHolder.Component.NoAuthLoginComponent.Phrase.ErrorMessage');
			},
		);
	}
}
